var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#FFE2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7304 30L25.7304 16C25.556 15.6922 25.303 15.4362 24.9973 15.2581C24.6917 15.08 24.3442 14.9861 23.9904 14.9861C23.6366 14.9861 23.2892 15.08 22.9835 15.2581C22.6778 15.4362 22.4249 15.6922 22.2504 16L14.2504 30C14.0741 30.3054 13.9816 30.6519 13.9824 31.0045C13.9832 31.3571 14.0772 31.7033 14.2549 32.0078C14.4325 32.3124 14.6876 32.5646 14.9941 32.7388C15.3007 32.9131 15.6478 33.0032 16.0004 33H32.0004C32.3513 32.9997 32.6959 32.907 32.9997 32.7313C33.3035 32.5556 33.5556 32.3031 33.7309 31.9991C33.9062 31.6951 33.9985 31.3504 33.9984 30.9995C33.9983 30.6486 33.9059 30.3039 33.7304 30Z",
    stroke: "#E7000B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21V25",
    stroke: "#E7000B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29H24.01",
    stroke: "#E7000B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectRequestIcon);
export default __webpack_public_path__ + "static/media/reject-request-icon.663961839ac65bf74f0c665bfa4a15cd.svg";
export { ForwardRef as ReactComponent };